<template lang="pug">
PrButton(@nv-enter="$emit('nv-enter', $event)", v-bind="$props")
  slot
</template>

<script>
import styled from "vue-styled-components"

const Props = {
  fw: Boolean,
  xsmall: Boolean,
  small: Boolean,
  outline: Boolean
}
const PrButton = styled("div", Props)`
  display: inline-block;
  text-align: center;
  margin: 0 auto;

  background: ${props => (props.theme.options.outline || props.outline ? "rgba(0,0,0,.15);" : props.theme.color.surface)};
  color: ${props => props.theme.color.onSurface};
  ${props => "border: 1px solid " + (props.outline ? props.theme.color.onSurface : props.theme.color.border) + ";"}
  ${props => props.fw && "width:100%;"}
  ${props =>
    props.xsmall
      ? "padding: 0.25em 1em; font-size: " + props.theme.font.xsmall + ";"
      : props.small
      ? "padding: 0.35em 1.25em; font-size: " + props.theme.font.small + ";"
      : "padding: 0.5em 1.5em; font-weight:300; font-size: " + props.theme.font.base + ";"}
      
  
  &.active {
    border-bottom: 2px solid ${props => props.theme.color.primary};
    position:relative;
  }

`
export default {
  name: "pr-button",
  components: {
    PrButton
  },
  props: {
    ...Props
  }
}
</script>
